import { productAttributesStyles } from "@insite/content-library/Components/ProductAttributes";
import { css } from "styled-components";

productAttributesStyles.attributeTypeGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        overflow: hidden;
    `,
};
productAttributesStyles.attributeValueGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        overflow: hidden;
    `,
};
